// Compatibility shim for DB module
// Re-export everything from the implementation file named 'indexDB 2.js'

import * as impl from './indexDB 2'

export * from './indexDB 2'
export default impl

// CommonJS interop for consumers using require()
try {
  // eslint-disable-next-line no-undef
  module.exports = impl
} catch {}